import { render, staticRenderFns } from "./ListCandidato.vue?vue&type=template&id=4ae9644c"
import script from "./ListCandidato.vue?vue&type=script&lang=js"
export * from "./ListCandidato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports